/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisterRequest } from '../../models/register-request';
import { Site } from '../../models/site';

export interface MembersRegisterPost$Params {
  'CF-Connecting-IP'?: string;
  'x-app'?: Site;
  body: RegisterRequest;
}

export function membersRegisterPost(
  http: HttpClient,
  rootUrl: string,
  params: MembersRegisterPost$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, membersRegisterPost.PATH, 'post');
  if (params) {
    rb.header('CF-Connecting-IP', params['CF-Connecting-IP'], {});
    rb.header('x-app', params['x-app'], {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(rb.build({ responseType: 'text', accept: '*/*', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({
          body: undefined,
        }) as StrictHttpResponse<void>;
      }),
    );
}

membersRegisterPost.PATH = '/members/register';
